import Vue from 'vue'
import {CONFIG} from './config.js';

const ResetPasswordForm = Vue.component('reset_password_form', {
    template: '#reset_password_form',
    props: ["token"],
    data: function() {
        return {
            password: null,
            repeat: null,
            passwordChanged: false,
            repeatChanged: false
        }
    },
    watch: {
        password: function(v) {
            this.passwordChanged = (v !== null);
        },
        repeat: function(v) {
            this.repeatChanged = (v !== null);
        }
    },
    computed: {
        invalidPasswordFeedback: function() {
            if (!this.passwordChanged) {
                return '';
            }

            if (!this.password) {
                return this.$t('resetPassword.noPasswordError');
            }

            return '';
        },
        isPasswordValid: function() {
            if (!this.passwordChanged) {
                return null;
            }

            return this.invalidPasswordFeedback == '';
        },
        invalidRepeatFeedback: function() {
            if (!this.repeatChanged) {
                return '';
            }

            if (!this.repeat) {
                return this.$t('resetPassword.noPasswordError');
            } else if (this.repeat != this.password) {
                return this.$t('resetPassword.notEqualPasswordsError');
            }

            return '';
        },
        isRepeatValid: function() {
            if (!this.repeatChanged) {
                return null;
            }

            return this.invalidRepeatFeedback == '';
        },
        isValid: function() {
            return this.isPasswordValid && this.isRepeatValid;
        }
    },
    methods: {
        reset: function() {
            if (!this.isValid) {
                return;
            }

            var self = this;

            this.$request("post", CONFIG.api.endpoints.resetPassword,
                function() {
                    self.$ebus.$emit("msg:new",
                        {
                            type: "success-modal",
                            data: {
                                text: self.$t("resetPassword.success"),
                                variant: "success",
                                onclick: () => self.$router.push("/login")
                            }
                        }
                    )
                },
                {
                    data: {
                        "new_password_": this.password,
                        "new_password_confirmation_": this.repeat
                    },
                    headers: {
                        'Authorization': "Bearer " + this.$route.params.token
                    }
                }
            )
        }
    },
    filters: {
        uppercase: function(v) {
            return v.toUpperCase();
        }
    }
})

export default ResetPasswordForm;